import { render, staticRenderFns } from "./courseCategoryDialog.vue?vue&type=template&id=2189eb30&scoped=true&"
import script from "./courseCategoryDialog.vue?vue&type=script&lang=js&"
export * from "./courseCategoryDialog.vue?vue&type=script&lang=js&"
import style0 from "./courseCategoryDialog.vue?vue&type=style&index=0&id=2189eb30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2189eb30",
  null
  
)

export default component.exports